import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9cd29d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-container w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 1,
  class: "text-red"
}

import { requiredRule } from "@/utils/rules";
import { PropType } from "vue";
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectInput',
  props: {
  modelValue: String,
  label: { type: String, default: "" },
  icon: String,
  items: Object as PropType<string[]>,
  rules: null,
  required: Boolean,
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;




const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const rules = computed(() =>
  props.required ? [...(props.rules || []), requiredRule] : props.rules
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createBlock(_component_v_input, {
    "model-value": value.value,
    rules: rules.value
  }, {
    default: _withCtx(({ isValid }) => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("select", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
          class: _normalizeClass(`w-100 px-2 bg-gray pb-1 pt-4 ${
            isValid.value === false ? 'error' : ''
          }`),
          required: ""
        }, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item,
              value: item
            }, _toDisplayString(item), 9, _hoisted_3))
          }), 128))
        ], 2), [
          [_vModelSelect, value.value]
        ]),
        _createElementVNode("label", null, [
          (__props.icon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                size: "24",
                class: _normalizeClass(`icon mdi ${__props.icon}`)
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    message: _withCtx(({ message }) => [
      _createVNode(_component_v_icon, {
        size: "12",
        class: "mdi mdi-alert-circle-outline"
      }),
      _createTextVNode(" " + _toDisplayString(message), 1)
    ]),
    _: 1
  }, 8, ["model-value", "rules"]))
}
}

})